var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -134.907,
    y1: 204.572,
    x2: -134.896,
    y2: 204.572,
    gradientTransform: "matrix(1538, 0, 0, -961.25, 207495, 196661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e62d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#df3f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#df3f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e62d2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -134.907,
    y1: 203.781,
    x2: -134.896,
    y2: 203.781,
    gradientTransform: "matrix(1538, 0, 0, -961.25, 207495, 195892)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -134.907,
    y1: 205.363,
    x2: -134.896,
    y2: 205.363,
    gradientTransform: "matrix(1538, 0, 0, -961.25, 207495, 197430)",
    xlinkHref: "#a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_scala") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.384,19.231v2.154c0,.363,7.833.971,12.937,2.154,2.465-.571,4.295-1.277,4.295-2.154V19.231c0-.877-1.83-1.582-4.295-2.154-5.1,1.183-12.937,1.791-12.937,2.154",
    style: {
      fill: "#7f0c1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.384,10.615v2.154c0,.363,7.833.971,12.937,2.154,2.465-.571,4.295-1.277,4.295-2.154V10.615c0-.877-1.83-1.582-4.295-2.154-5.1,1.183-12.937,1.791-12.937,2.154",
    style: {
      fill: "#7f0c1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.384,14.923v6.462c0-.538,17.232-1.615,17.232-4.308V10.615c0,2.692-17.232,3.769-17.232,4.308",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.384,6.308V12.77c0-.538,17.232-1.615,17.232-4.308V2c0,2.692-17.232,3.769-17.232,4.308",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.384,23.538V30c0-.538,17.232-1.615,17.232-4.308V19.231c0,2.692-17.232,3.769-17.232,4.308",
    style: {
      fill: "url(#c)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScala);
export default __webpack_public_path__ + "static/media/icon_scala.f8aedabb32765d38ccd844971c1ac129.svg";
export { ForwardRef as ReactComponent };